module.exports = __webpack_public_path__ + "media/src/images/icons/gray-arrow-circle-down-840dd5e1591a0efb20956639b0663392.svg";